const dateFormatter = new Intl.DateTimeFormat('it-IT', {
  weekday: 'short',
  day: 'numeric',
  month: 'long',
});

const timeFormatter = new Intl.DateTimeFormat('it-IT', {
  hour: '2-digit',
  minute: '2-digit',
});

const currencyFormatter = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
});

const shortDateFormatter = new Intl.DateTimeFormat('it-IT', {
  day: 'numeric',
  month: 'short',
});

export function formatDateIT(isoDate) {
  if (!isoDate) return '';
  const [y, m, d] = isoDate.slice(0, 10).split('-').map(Number);
  return dateFormatter.format(new Date(y, m - 1, d));
}

export function formatDateShortIT(isoDate) {
  if (!isoDate) return '';
  const [y, m, d] = isoDate.slice(0, 10).split('-').map(Number);
  return shortDateFormatter.format(new Date(y, m - 1, d));
}

export function formatDateRangeIT(dateStart, dateEnd) {
  if (!dateStart || !dateEnd) return '';
  return `${formatDateShortIT(dateStart)} – ${formatDateShortIT(dateEnd)}`;
}

export function formatTimeIT(isoTimestamp) {
  if (!isoTimestamp) return '';
  return timeFormatter.format(new Date(isoTimestamp));
}

export function formatEur(amount) {
  const value = Number(amount);
  if (Number.isNaN(value)) return currencyFormatter.format(0);
  return currencyFormatter.format(value);
}

export function timeAgo(isoTimestamp) {
  if (!isoTimestamp) return '';
  const diffMs = Date.now() - new Date(isoTimestamp).getTime();
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return 'adesso';
  if (diffMin < 60) return `${diffMin} min fa`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `${diffH} h fa`;
  const diffD = Math.floor(diffH / 24);
  return `${diffD} g fa`;
}
